'use strict';

import Alerts from 'lib/alerts';
import template from '../../templates/payrollSubmissions/Submission.ejs';
import loader from 'helpers/loader';
import Attachments from 'newCollections/attachments.js';
import Payroll from 'newModels/payroll.js';

module.exports = Backbone.View.extend({
    tagName: 'tr',

    events: {
        'click .js-confirm-pickup':      'confirmPickup',
        'click .js-received-payment':    'receivedPayment',
        'click .js-generate-forms':      'generateForms',
        'click .js-awaiting-signatures': 'awaitingSignatures',
        'click .js-awaiting-submission': 'awaitingSubmission',
        'click .js-submitted-to-govt':   'submittedToGovernment',
        'click .js-notify-company':      'notifyCompany',
        'change .js-upload-file':        'uploadFiles',
        'click .js-cancel':              'cancel',
        'click .js-revert':              'revert'
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            attachments: null
        });

        this.model.on('sync', this.render, this);

        return this.render();
    },

    render: function() {
        this.$el.html(template({
            model:      this.model,
            statusText: this.getStatusText(this.model.get('status') || 0)
        }));

        this.$pickDate = this.$('.pickup-date');
        this.$pickDate.datepicker({
            weekStart:      1,
            autoclose:      true,
            todayHighlight: true
        }).datepicker('setDate', this.model.get('chequePickupDate'));

        this.renderAttachments();

        return this;
    },

    renderAttachments: function() {
        this.$('.js-attachments').html('');

        if (!_.contains([5, 8], this.model.get('status'))) {
            return;
        }

        this.options.attachments.findByTags(
            (this.model.get('status') === 5) ?
                ['payroll', 'form'] :
                ['payroll', 'upload']
        ).each(this.renderAttachment.bind(this));

        return this;
    },

    renderAttachment: function(attachment) {
        var $attachments = this.$('.js-attachments');

        var $link = $('<a>').attr({
            href: attachment.downloadUrl(),
            target: '_blank'
        }).text(attachment.get('name'));
        var $delete = $('<i class="fa fa-times"></i>');

        var $attachment = $('<div class="item">')
            .append($delete)
            .append($link)
            .append(' (' + (attachment.get('description') || 'unknown') + ')');

        $delete.on('click', function() {
            this.promptDeleteFile(attachment, $attachment);
        }.bind(this));

        $attachments.append($attachment);
    },

    getStatusText: function(status) {
        switch (status) {
            case 3:
                return 'Submitted. Awaiting pick up date confirmation';
            case 4:
                return 'Pickup date confirmed';
            case 5:
                return 'Payments received';
            case 6:
                return 'Forms awaiting signatures';
            case 7:
                return 'Forms awaiting submission';
            case 8:
                return 'Forms submitted to government';
            case 9:
                return 'Employer notified';
            default:
                return 'Unknown status';
        }
    },

    saveStatus: function($button, status, chequePickupDate) {
        var stopLoader = loader.startFullScreen($button);

        this.model.setStatus(status, chequePickupDate)
            .then(payroll => {
                this.model = payroll.model;
                this.render();
            })
            .catch(err => { Alerts.show('criticalError', err); })
            .finally(stopLoader);
    },

    confirmPickup: function(ev) {
        var chequePickupDate = this.$pickDate.datepicker('getDate');
        this.saveStatus(this.$(ev.currentTarget), 4, chequePickupDate);
    },

    receivedPayment: function(ev) {
        this.saveStatus(this.$(ev.currentTarget), 5);
    },

    awaitingSignatures: function(ev) {
        this.saveStatus(this.$(ev.currentTarget), 6);
    },

    awaitingSubmission: function(ev) {
        this.saveStatus(this.$(ev.currentTarget), 7);
    },

    submittedToGovernment: function(ev) {
        this.saveStatus(this.$(ev.currentTarget), 8);
    },

    notifyCompany: function(ev) {
        this.saveStatus(this.$(ev.currentTarget), 9);
    },

    uploadFiles: function(ev) {
        var $button     = this.$('.js-upload-files').find('.dropdown-toggle');
        var description = this.$(ev.currentTarget).data('description');
        var tags        = this.$(ev.currentTarget).data('tags').split(' ');
        var files       = this.$(ev.currentTarget)[0].files;
        var stopLoader  = loader.startFullScreen($button);
        var promises;

        if (files.length === 0) {
            stopLoader();
            return false;
        }

        tags.push('payroll', 'upload', 'payroll-archive');

        promises = _.map(files, function(file) {
            var originalName = file.name;
            var ext          = file.name.split('.').pop();
            return (new Parse.File('file.' + ext, file))
                .save()
                .then(function(file) {
                    return Parse.Cloud.run('createAttachment', {
                        file:        file,
                        name:        originalName,
                        tags:        tags,
                        description: description,

                        attachmentStore: this.model.get('attachmentStore').id
                    });
                }.bind(this));
        }.bind(this));

        Parse.Promise.when(promises).then(function(attachments) {
            this.options.attachments.add(attachments);
            this.renderAttachments();
        }.bind(this), err => { Alerts.show('criticalError', err); })
            .always(stopLoader);
    },

    promptDeleteFile: function(attachment, $el) {
        Alerts.show('dangerConfirm', {
            title:             'Are you sure you want to delete file?',
            confirmButtonText: 'Yes, Delete',

            callback: isConfirm => {
                if (isConfirm) {
                    this.deleteFile(attachment, $el);
                }
            }
        });
    },

    deleteFile: function(attachment, $el) {
        var stopLoader = loader.startFullScreen();

        $el.addClass('disabled');

        attachment.destroy()
            .then(() => {
                this.options.attachments.remove(attachment.id);
                $el.remove();
            })
            .catch(err => {
                $el.removeClass('disabled');
                Alerts.show('criticalError', err);
            })
            .finally(stopLoader);
    },

    generateForms: function(ev) {
        var $button    = this.$(ev.currentTarget);
        var stopLoader = loader.startFullScreen($button);

        this.model.generateForms()
            .then(() => {
                let attachments = new Attachments(null,
                    {attachable: this.model}
                );
                attachments.fetch()
                    .then(() => {
                        this.options.attachments.add(attachments.models);
                        this.render();
                    });
            })
            .finally(stopLoader);
    },

    cancel: function() {
        var warnTextByStatus = {
            5: 'You have already recevied payment for this payroll. ',
            6: 'Government forms have already been signed. ',
            7: 'Forms have already been submitted to the government. ',
            8: 'Forms have been processed. '
        };

        Alerts.show('dangerConfirm', {
            title: 'Are you sure you want to cancel this payroll?',
            text:  (warnTextByStatus[this.model.get('status')] || '') +
                'You will lose any generated or uploaded forms and receipts',
            confirmButtonText: 'Yes, Cancel',
            callback: isConfirm => {
                if (!isConfirm) {
                    return;
                }

                this.model.destroy().then(
                    () => this.remove(),
                    err => Alerts.show('criticalError', err)
                );
            }
        });
    },

    revert: function() {
        let lastPayrollReady = Payroll.fetchCurrent(this.model.get('company'));
        Alerts.show('dangerConfirm', {
            title: 'Are you sure you want to revert this payroll?',
            text:  'You will lose all generated and uploaded files, ' +
                'including any emailed payslips and signed forms.',
            confirmButtonText: 'Yes, Revert'
        }).then(() => {
            return lastPayrollReady.then(payroll => {
                if (!payroll) {
                    return;
                }
                if (payroll.samePeriodAs(this.model)) {
                    return Alerts.show('dangerConfirm', {
                        title: 'Already saved payroll found',
                        text: 'The user already has a saved payroll for the ' +
                            'current month. What do you wish to do with this ' +
                            'payroll?',
                        confirmButtonText: 'Revert and discard',
                        cancelButtonText: 'Revert and keep'
                    }).then(() => {
                        // Discard
                        return 'discard';
                    }, () => {
                        // Keep
                        return 'keep';
                    });
                }
            }).then(action => {
                this.model.revert({
                    savedPayrollAction: action
                })
                .then(() => this.remove())
                .catch(err => Alerts.show('criticalError', err));
            });
        });
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/payrollSubmissions/Submission.js